import { getFieldErrors, isApiError } from '@/services/api';
import { apiErrorMessage } from '@/shared/utils/apiErrorMessage';

const REFUSAL_COPY: Record<string, string> = {
    invoice_already_reversed: 'This invoice has already been reversed.',
    agreement_not_active: 'This agreement is not active, so the invoice cannot be reversed.',
    submission_not_published: 'This invoice is still being processed. Wait a moment and try again.',
};

const REFUSED_FALLBACK = 'This invoice cannot be reversed.';
const FORBIDDEN_COPY = 'You do not have permission to reverse this invoice.';
const NOT_FOUND_COPY = 'This invoice could not be found. It may no longer be available to you.';
const UNAVAILABLE_COPY = 'The invoice could not be reversed because a connected service did not respond. Nothing was changed; try again.';
const FALLBACK_COPY = 'The invoice could not be reversed. Try again.';

function refusalReason(error: { data?: unknown }): string | null {
    const reasons = (error.data as { reasons?: unknown } | undefined)?.reasons;
    if (!Array.isArray(reasons)) return null;
    const first = reasons[0] as { code?: unknown } | undefined;
    return typeof first?.code === 'string' ? first.code : null;
}

function unprocessableCopy(error: { code?: string; data?: unknown; message: string }): string {
    if (error.code === 'invoice_reversal_refused') {
        const reason = refusalReason(error);
        return (reason !== null && REFUSAL_COPY[reason]) || REFUSED_FALLBACK;
    }
    return getFieldErrors(error).note?.[0] ?? error.message;
}

export function reversalErrorMessage(error: unknown): string {
    if (!isApiError(error)) return apiErrorMessage(error, FALLBACK_COPY);
    if (error.status === 403) return FORBIDDEN_COPY;
    if (error.status === 404) return NOT_FOUND_COPY;
    if (error.status === 422) return unprocessableCopy(error);
    if (error.status === 502) return UNAVAILABLE_COPY;
    return FALLBACK_COPY;
}
